export default __webpack_public_path__ + "static/media/section2b-grid3img.bd1f6790.svg";